export type CopilotResponse = {
  id: string
  prompt: string
  response: string
}

export enum CopilotEndpoint {
  CreatePracticeProblem = "createPracticeProblem",
  CreateAlternativeExplanation = "createAlternativeExplanation",
}

export type CopilotCreateSuggestionResult = {
  data?: {
    copilotCreateSuggestion: {
      copilotResponse?: string
      failures: { message: string }[]
    }
  }
}
